import React from "react";
import { ParishHistoryCard } from "../../components/About/ParishHistoryCard";
import { PageHero } from "../../components/Global/PageHero";
import { BackToTop } from "../../templates/BackToTop";

export const ParishHistory = () => (
  <div>
    <PageHero
      eyebrow="Our Story"
      title="Salvation Parish"
      highlight="History"
      subtitle="Dive right in and learn about this great denomination."
    />
    <ParishHistoryCard />
    <BackToTop />
  </div>
);
